var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var React = require("react");

var EditorJsonify = require("../mixins/editor-jsonify.jsx");
var Changeable = require("../mixins/changeable.jsx");
var NumberInput = require("../components/number-input.jsx");
var TextInput = require("../components/text-input.jsx");

var MoleculeWidgetEditor = React.createClass({
    displayName: "MoleculeWidgetEditor",

    propTypes: _extends({}, Changeable.propTypes, {
        rotationAngle: React.PropTypes.number,
        smiles: React.PropTypes.string
    }),

    change: function change() {
        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return Changeable.change.apply(this, args);
    },


    updateMolecule: function updateMolecule(newValue) {
        this.change({ smiles: newValue });
    },

    updateRotation: function updateRotation(newValue) {
        this.change({ rotationAngle: newValue });
    },

    serialize: function serialize() {
        return EditorJsonify.serialize.call(this);
    },


    render: function render() {
        return React.createElement(
            "div",
            null,
            React.createElement(
                "div",
                null,
                React.createElement(
                    "label",
                    null,
                    "SMILES:\xA0",
                    React.createElement(TextInput, {
                        onChange: this.updateMolecule,
                        value: this.props.smiles
                    })
                )
            ),
            React.createElement(
                "div",
                null,
                React.createElement(
                    "label",
                    null,
                    "Rotation (deg):\xA0",
                    React.createElement(NumberInput, {
                        onChange: this.updateRotation,
                        value: this.props.rotationAngle
                    })
                )
            )
        );
    }
});

module.exports = MoleculeWidgetEditor;


/*****************
 ** WEBPACK FOOTER
 ** ./src/widgets/molecule-editor.jsx
 ** module id = 129
 ** module chunks = 0 1
 **/